import { render, staticRenderFns } from "./ArticleBodyMultipageNavigation.vue?vue&type=template&id=7ac3c1e8"
import script from "./ArticleBodyMultipageNavigation.vue?vue&type=script&lang=ts"
export * from "./ArticleBodyMultipageNavigation.vue?vue&type=script&lang=ts"
import style0 from "./ArticleBodyMultipageNavigation.vue?vue&type=style&index=0&id=7ac3c1e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports